/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessReviewExcludedSection'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/BusinessReviewExcludedSection'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewExcludedSectionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessReviewExcludedSection);
  }
}(this, function(ApiClient, BusinessReviewExcludedSection) {
  'use strict';

  /**
   * BusinessReviewExcludedSection service.
   * @module api/BusinessReviewExcludedSectionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new BusinessReviewExcludedSectionApi. 
   * @alias module:api/BusinessReviewExcludedSectionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the businessReviewExcludedSectionAddPut operation.
     * @callback module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessReviewExcludedSection} body 
     * @param {module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.businessReviewExcludedSectionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewExcludedSectionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewExcludedSectionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/BusinessReviewExcludedSection/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewExcludedSectionEditPut operation.
     * @callback module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessReviewExcludedSection} body 
     * @param {module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessReviewExcludedSectionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewExcludedSectionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewExcludedSectionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessReviewExcludedSection/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewExcludedSectionLoadDefaultExcludedSectionsGet operation.
     * @callback module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionLoadDefaultExcludedSectionsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BusinessReviewExcludedSection>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadDefaultExcludedSections
     * @param {String} _4SAPIAppID 
     * @param {module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionLoadDefaultExcludedSectionsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BusinessReviewExcludedSection>}
     */
    this.businessReviewExcludedSectionLoadDefaultExcludedSectionsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewExcludedSectionLoadDefaultExcludedSectionsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [BusinessReviewExcludedSection];

      return this.apiClient.callApi(
        '/BusinessReviewExcludedSection/loadDefaultExcludedSections', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewExcludedSectionLoadUserExcludedSectionsGet operation.
     * @callback module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionLoadUserExcludedSectionsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BusinessReviewExcludedSection>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadUserExcludedSections
     * @param {String} _4SAPIAppID 
     * @param {module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionLoadUserExcludedSectionsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BusinessReviewExcludedSection>}
     */
    this.businessReviewExcludedSectionLoadUserExcludedSectionsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewExcludedSectionLoadUserExcludedSectionsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [BusinessReviewExcludedSection];

      return this.apiClient.callApi(
        '/BusinessReviewExcludedSection/loadUserExcludedSections', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewExcludedSectionMergeAllPut operation.
     * @callback module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/BusinessReviewExcludedSection>} body 
     * @param {module:api/BusinessReviewExcludedSectionApi~businessReviewExcludedSectionMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.businessReviewExcludedSectionMergeAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewExcludedSectionMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewExcludedSectionMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/BusinessReviewExcludedSection/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
